import { ActionTree } from 'vuex';
import { ContractsState } from './types';
import { RootState } from '@/types';
import router from '@/router';
import { contractService } from '@/services/contract.services';


export const actions: ActionTree<ContractsState, RootState> = {
    get({ commit }, { page = 1, perPage = 10, search = '', canceled = false }): any {
        commit('setLoading');
        contractService.index(page, perPage, search, canceled)
        .then((response) => {
            const payload: any = response && response.data;
            commit('setData', payload);
        }, (error) => {
            commit('setError', error);
        });
    },
};
